import { FiledNameByBodyPart } from '@/pages/service/body-measurement/measurement-content/enumData';
import { GirthChangeItem } from '../component';
import cx from './index.module.scss';

interface Props {
  serviceDetail: GetServiceOrderDetailResponse;
  beforeHandData: MeasurementResult;
  afterHandData: MeasurementResult;
}

const RadioFrequencyGirth: React.FC<Props> = ({ serviceDetail, beforeHandData, afterHandData }) => {
  return (
    <>
      <div className={cx('title')}>本次理疗围度变化</div>
      <div className={cx('content')}>
        {FiledNameByBodyPart?.[serviceDetail?.bodyPart]?.map(item => {
          return (
            <div key={item.name} style={{ order: item?.order }}>
              <GirthChangeItem
                label={item.label}
                unit={item.unit}
                beforeVal={beforeHandData?.[item?.name]}
                afterVal={afterHandData?.[item?.name]}
                listLength={FiledNameByBodyPart?.[serviceDetail?.bodyPart]?.length}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default RadioFrequencyGirth;
